import React from 'react';
import './App.scss';
import './global.scss'
import './assets/fonts/css/general-sans.css'
import './assets/fonts/css/tungsten.css'
import './assets/fonts/css/poppins.css'
import {Route, Routes} from "react-router-dom";
import DataConsent from "./pages/data-consent/DataConsent";
import CaptureDocumentFront from "./pages/capture-front/CaptureDocumentFront";
import CaptureDocumentBack from "./pages/capture-back/CaptureDocumentBack";
import CaptureSelfie from "./pages/capture-selfie/CaptureSelfie";
import InitiateVerification from "./pages/initiate-verification/InitiateVerification";
import Information from "./pages/information/Information";
import CompletePage from "./pages/Complete";
import {ThemeSetterPage} from "./pages/ThemeSetter";
import {TakeSelfiePage} from "./pages/take-selfie/TakeSelfie";
import {StartPage} from "./pages/start/Start";
import {LogoComponent} from "./components/common/logo/LogoComponent";
import {VerifyToken} from "./pages/token/VerifyToken";
import {DocumentChoicePage} from "./pages/document-choice/DocumentChoice";
import {MyMahiPage} from "./pages/mymahi/MyMahi";
import {MyMahiCompletePage} from "./pages/mymahi-complete/MyMahiComplete";
import {MyMahiErrorPage} from "./pages/mymahi-error/MyMahiError";
import {ErrorPage} from "./pages/error/Error";
import GlobalBoundary from "./boundary/GlobalBoundary";
import NavigatorBridge from "./boundary/NavigatorBridge";

const App: React.FC = () => {

    return (
        <div className={`app-background`}>
            <div className={`app-logo`}>
                <LogoComponent white/>
            </div>

            <NavigatorBridge />
            <GlobalBoundary>
                <Routes>
                    <Route path="/:verificationId/complete" element={<CompletePage/>}/>
                    <Route path="/:verificationId/information" element={<Information/>}/>
                    <Route path="/:verificationId/selfie" element={<CaptureSelfie/>}/>
                    <Route path="/:verificationId/take-selfie" element={<TakeSelfiePage/>}/>
                    <Route path="/:verificationId/back" element={<CaptureDocumentBack/>}/>
                    <Route path="/:verificationId/front" element={<CaptureDocumentFront/>}/>
                    <Route path="/:verificationId/consent" element={<DataConsent/>}/>
                    <Route path="/:verificationId/mymahi/error" element={<MyMahiErrorPage/>}/>
                    <Route path="/:verificationId/mymahi/complete" element={<MyMahiCompletePage/>}/>
                    <Route path="/:verificationId/mymahi" element={<MyMahiPage/>}/>
                    <Route path="/:verificationId/document" element={<DocumentChoicePage/>}/>
                    <Route path="/:verificationId/start" element={<StartPage/>}/>
                    <Route path="/:verificationId/error" element={<StartPage/>}/>
                    <Route path="/:verificationId" element={<ThemeSetterPage/>}/>
                    <Route path="/validate/:token" element={<VerifyToken/>}/>
                    <Route path="/error" element={<ErrorPage/>}/>
                    <Route path="/" element={<InitiateVerification/>}/>
                </Routes>
            </GlobalBoundary>
        </div>

    )
}

export default App;
